import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { ArrowUUpLeft, Eye } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonation, user } = useAuth();
  const nav = useNavigate();

  if (!impersonating || user?.role !== "super_admin") return null;

  const back = async () => {
    try {
      await stopImpersonation();
      toast.success("Volviste al panel Super Admin");
      nav("/admin/clientes");
    } catch {
      toast.error("No se pudo salir de la sesión del cliente");
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="bg-amber-500 text-slate-900 px-4 py-2 flex items-center justify-between gap-4"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye size={16} weight="bold" />
        <span>
          Viendo SIGSAOP como cliente
          {" "}<strong data-testid="impersonating-client-name">{impersonating.name}</strong>
        </span>
      </div>
      <button
        onClick={back}
        data-testid="exit-impersonation-btn"
        className="flex items-center gap-2 text-xs font-semibold bg-slate-900 text-white rounded-md px-3 py-1.5 hover:bg-slate-800"
      >
        <ArrowUUpLeft size={14} />
        Volver al panel
      </button>
    </div>
  );
}
